import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import translate from '../../translate';
import StripeService from '../../../services/stripeService';
import CustomRadio from './CustomRadio';

function StripeForm({
  t,
  id,
  label,
  onFinish,
  onCancel,
  isCheckout,
  attachToUser,
  onChangeAttachToUser,
  showSaveCard,
  isSubscription,
}) {
  const cardEl = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const elements = StripeService.elements();
    const card = elements.create('card', { hidePostalCode: true });
    cardEl.current = card;
    card.addEventListener('change', ({ error: inputErr }) =>
      setError(StripeService.handleError(inputErr)),
    );
    card.mount(`#${id}`);

    return () => cardEl.current.destroy();
  }, []);

  const handleAdd = async () => {
    try {
      const result = await StripeService.createToken(cardEl.current);
      onFinish(result);
    } catch (err) {
      setError(err);
    }
  };

  return (
    <div className="stripe-container">
      <label htmlFor={id}>{t(label)}</label>
      <div className="stripe-input-container">
        <div id={id} />
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="stripe-button stripe-cancel-button"
          >
            {t('cancel')}
          </button>
        )}
        <button
          type="button"
          onClick={handleAdd}
          className="stripe-button stripe-finish-button"
        >
          {t('add_card')}
        </button>
      </div>
      <div className="stripe-error-container" role="alert">
        {error ? t(error) : ''}
      </div>
      {isCheckout && showSaveCard && !isSubscription && (
        <div className="save-card-wrapper credit-card-info">
          <div className="m-checkbox m-checkbox--state-success">
            <CustomRadio
              id="attachCardToUser"
              value={attachToUser}
              onClick={onChangeAttachToUser}
              checked={attachToUser}
              label={t('credit.card.save')}
            />
          </div>
        </div>
      )}
    </div>
  );
}

StripeForm.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  onFinish: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isCheckout: PropTypes.bool,
  attachToUser: PropTypes.bool,
  onChangeAttachToUser: PropTypes.func,
  showSaveCard: PropTypes.bool,
  isSubscription: PropTypes.bool,
};

StripeForm.defaultProps = {
  id: 'stripe-input',
  label: 'stripe_inputLabel',
  isCheckout: false,
  attachToUser: true,
  onChangeAttachToUser: null,
  showSaveCard: true,
  isSubscription: false,
};

export default translate(StripeForm);
